// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2YAfk","requiredAsterisk":"Info_requiredAsterisk__UEENJ"};